export const commit = {"hash":"7c6922a","message":"use read buttons in keyboard"};
export const key = "alohomora";
export const MODE = "production";
export const NODE_ENV = "production";
export const SSR = false;